import React, { useEffect, useState } from 'react';
import WindowFrame from './WindowFrame';
import { subscribeWindows } from '../../utils/functions/windowManager';

// Mount ครั้งเดียวที่ root (index.js) นอก <Switch>/<Route> — เก็บ WindowFrame ที่เปิดอยู่ทั้งหมด
// ไว้ที่นี่ (อ่านจาก windowManager.js) แทนที่จะให้แต่ละหน้าเรนเดอร์ WindowFrame ของตัวเอง เพราะ
// component ของหน้านั้นจะถูก unmount ทิ้งทันทีที่เปลี่ยนเส้นทาง ทำให้หน้าต่างที่เปิด/ย่อไว้หายไปด้วย
// ย้ายมา mount ที่นี่แทน — ไม่ว่าจะลิงก์ไปหน้าไหนก็ตาม หน้าต่างยังอยู่จนกว่าจะกดปิดเอง
const WindowManager = () => {
  const [windows, setWindows] = useState([]);
  useEffect(() => subscribeWindows(setWindows), []);

  return windows.map((w, idx) => (
    <WindowFrame
      key={w.id}
      open
      onClose={w.onClose}
      title={w.title}
      subtitle={w.subtitle}
      taskbarLabel={w.taskbarLabel}
      defaultWidth={w.defaultWidth}
      defaultHeight={w.defaultHeight}
      tileIndex={idx}
      tileCount={windows.length}
    >
      {w.render()}
    </WindowFrame>
  ));
};

export default WindowManager;
